import { checkFormsForImmixValues } from "./checkFormsForImmixValues";
import { checkFormsForDiceValues } from "./checkFormsForDiceValues";
import { checkInitialDataForImmixOrSentinelValues } from "./checkInitialDataForImmixOrSentinelValues";

export type AddCameraWizardResponse = {
  initial_data: Record<string, unknown>;
  forms: unknown[][];
  submit_object?: Record<string, unknown>;
};

export const buildAddCameraWizardResponse = (
  addCameraInfo: {
    initial_data?: Record<string, unknown>;
    forms?: unknown[][];
    submit_object?: Record<string, unknown>;
  }
): AddCameraWizardResponse => ({
  initial_data: {
    ...checkInitialDataForImmixOrSentinelValues(addCameraInfo?.initial_data ?? {}),
    // Add Camera should start with no product pre-selection.
    products: [],
  },
  forms: checkFormsForDiceValues(
    checkFormsForImmixValues(addCameraInfo?.forms ?? [])
  ),
  submit_object: addCameraInfo?.submit_object,
});

export const shouldRefreshAddCameraInfo = (
  addCameraInfo: { submit_object?: Record<string, unknown> } | null | undefined,
  siteId: string | number | null | undefined
): boolean => {
  if (!siteId) {
    return false;
  }

  const submitObject = addCameraInfo?.submit_object;
  if (!submitObject) {
    return true;
  }

  return Number(submitObject.customer) !== Number(siteId);
};

export const readAddCameraInfoFromStorage = (): {
  initial_data?: Record<string, unknown>;
  forms?: unknown[][];
  submit_object?: Record<string, unknown>;
} => {
  if (typeof localStorage === "undefined" || !localStorage.addCameraInfo) {
    return {};
  }

  try {
    return JSON.parse(localStorage.addCameraInfo);
  } catch {
    return {};
  }
};
